import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const stripBase = (url) => {
  if (!url) return "#";
  try { const u = new URL(url); return u.pathname + u.search; } catch { return url; }
};

function CardRow({ title, items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="mt-12" data-testid={`related-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <h2 className="font-playfair text-2xl text-white mb-5">{title}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((it) => (
          <Link key={it.id} to={stripBase(it.url)} className="group rounded-xl overflow-hidden border border-white/10 bg-white/5 hover:border-gold/40 transition-colors" data-testid={`related-card-${it.id}`}>
            <div className="aspect-[4/3] bg-black/40 overflow-hidden">
              {it.image ? <img src={it.image} alt={it.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                : <div className="w-full h-full grid place-items-center text-white/20 text-xs">{it.name}</div>}
            </div>
            <div className="p-3"><p className="text-sm text-white/85 group-hover:text-gold transition-colors truncate">{it.name}</p></div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default function RelatedContent({ data, showCategories = true, showBrands = true, showLinks = true }) {
  if (!data) return null;
  const links = [];
  Object.values(data.links_by_location || {}).forEach((arr) => (arr || []).forEach((l) => links.push(l)));
  const seen = new Set();
  const uniqueLinks = links.filter((l) => { const k = l.url; if (seen.has(k)) return false; seen.add(k); return true; });

  return (
    <>
      {showCategories && <CardRow title="Related Categories" items={data.categories} />}
      {showBrands && <CardRow title="Related Brands" items={data.brands} />}
      {showLinks && uniqueLinks.length > 0 && (
        <div className="mt-12" data-testid="related-links">
          <h2 className="font-playfair text-2xl text-white mb-4">You May Also Like</h2>
          <ul className="flex flex-wrap gap-2">
            {uniqueLinks.map((l, i) => (
              <li key={i}>
                <Link to={stripBase(l.url)} className="inline-flex items-center gap-1 rounded-full border border-white/15 text-white/75 hover:border-gold/40 hover:text-gold px-4 py-2 text-sm transition-colors" data-testid={`related-link-${i}`}>
                  {l.anchor || l.name} <ArrowUpRight className="h-3.5 w-3.5" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
